import capitalize from 'lodash/capitalize.js'

export const CUSTOMER_IDS = {
  TME: 'TME',
  SUBARU: 'SUBARU',
  NORDICS: 'NORDICS'
}

export const BRANDS_BY_CUSTOMER = {
  [CUSTOMER_IDS.TME]: ['toyota', 'lexus'],
  [CUSTOMER_IDS.SUBARU]: ['subaru'],
  [CUSTOMER_IDS.NORDICS]: ['subaru']
}

export const getBrandNamesByCustomerId = customerId => {
  return BRANDS_BY_CUSTOMER[customerId].map(b => capitalize(b)).join(' and ') || 'toyota'
}

export const SITE_TITLES_BY_CUSTOMER = {
  [CUSTOMER_IDS.TME]: 'Information for {{brand}} vehicle owners',
  [CUSTOMER_IDS.SUBARU]: '{{brand}} Owner\u2019s Information Portal',
  [CUSTOMER_IDS.NORDICS]: '{{brand}} Owner\u2019s Information Portal'
}

export const getSiteTitleByCustomerId = (customerId, brand = '') => {
  const template = SITE_TITLES_BY_CUSTOMER[customerId]
  if (!template) return ''

  const brandName = brand ? capitalize(brand) : ''
  return template.replace('{{brand}}', brandName)
}

export const getDefaultAppTitleByCustomerId = customerId => {
  const brandNames = getBrandNamesByCustomerId(customerId)
  return getSiteTitleByCustomerId(customerId, brandNames)
}

export const PUBLICATION_RETRIEVAL_CRITERIA = {
  TME: ['partNumber', 'modelType', 'lineOffDate'],
  SUBARU: ['partNumber'],
  NORDICS: ['partNumber']
}

export const APP_NAME_BY_CUSTOMER_ID = {
  [CUSTOMER_IDS.TME]: 'TME Customer Portal',
  [CUSTOMER_IDS.SUBARU]: "Subaru Owner's Information Portal",
  [CUSTOMER_IDS.NORDICS]: "Subaru Nordics Owner's Information Portal"
}
